import { render, staticRenderFns } from "./DiagArchiModal.vue?vue&type=template&id=d4e545b8&scoped=true&"
import script from "./DiagArchiModal.vue?vue&type=script&lang=js&"
export * from "./DiagArchiModal.vue?vue&type=script&lang=js&"
import style0 from "./DiagArchiModal.vue?vue&type=style&index=0&id=d4e545b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e545b8",
  null
  
)

export default component.exports